import API from "./index";

class ConfiguracaoSistemaService {
  constructor() {
    this.path = `/api/configuracoes-sistema`;
  }

  buscarPorTipo(tipoId, tituloPropriedade = "") {
    return API.get(`${this.path}/tipo/${tipoId}`, {
      params: { tituloPropriedade },
    });
  }

  buscarDepartamentoEmails(filtro = "") {
    return API.get(`${this.path}/departamento`, { params: { filtro } });
  }

  async cadastrarDepartamentoEmail(departamentoEmailDTO) {
    try {
      const response = await API.post(`${this.path}/departamento`, departamentoEmailDTO);
      return response;
    } catch (error) {
      console.error("Erro ao cadastrar e-mail do departamento:", error);
      throw error;
    }
  }

  atualizarConfiguracao(configuracao) {
    return API.put(`${this.path}/${configuracao.id}`, configuracao);
  }

  enviarTesteEmail(testeEmailData) {
    return API.post(`${this.path}/enviar-teste-email`, testeEmailData);
  }
}

export default new ConfiguracaoSistemaService();
